/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
    EventNameToJSONTyped,
} from './EventName';

/**
 * 
 * @export
 * @interface SDKEventPersonLoggedOutV1
 */
export interface SDKEventPersonLoggedOutV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventPersonLoggedOutV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventPersonLoggedOutV1
     */
    person_id: string;
}



/**
 * Check if a given object implements the SDKEventPersonLoggedOutV1 interface.
 */
export function instanceOfSDKEventPersonLoggedOutV1(value: object): value is SDKEventPersonLoggedOutV1 {
    if (!('event_name' in value) || value['event_name'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    return true;
}

export function SDKEventPersonLoggedOutV1FromJSON(json: any): SDKEventPersonLoggedOutV1 {
    return SDKEventPersonLoggedOutV1FromJSONTyped(json, false);
}

export function SDKEventPersonLoggedOutV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventPersonLoggedOutV1 {
    if (json == null) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': json['person_id'],
    };
}

export function SDKEventPersonLoggedOutV1ToJSON(json: any): SDKEventPersonLoggedOutV1 {
    return SDKEventPersonLoggedOutV1ToJSONTyped(json, false);
}

export function SDKEventPersonLoggedOutV1ToJSONTyped(value?: SDKEventPersonLoggedOutV1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_name': EventNameToJSON(value['event_name']),
        'person_id': value['person_id'],
    };
}

